import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactComponent as CurrentTaskIconSvg } from "../../assets/svg/current-task-target.svg";

const CurrentTaskIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <CurrentTaskIconSvg fill="currentColor" />
    </SvgIcon>
  );
};

export { CurrentTaskIcon };
